import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { normalizeText } from '../../Utils/FormatUtils';
import { getTranslatedKey } from '../../Utils/TranslateUtils';

const percentageSize = 1.3;

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 15 * percentageSize : 15)}px;
  font-weight: 200;
  margin-top: ${({ margin }) => (margin ? '25px' : '0')};

  @media screen and (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    width: 95%;
  }
`;

const DropdownButton = styled.button`
  padding: 6px;
  width: 100%;
  color: white;
  border: none;
  border-bottom: 1px solid;
  outline: none;
  background-color: transparent;
  text-align: start;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const DropdownListWrapper = styled.div`
  z-index: 100;
  width: 100%;
  position: ${({ fixed }) => (fixed ? 'unset' : 'absolute')};
  top: 100%;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 241.5px;
  }
`;

const DropdownList = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #333333;
  border: 1px solid #333333;
  color: white;
  z-index: 100;
  list-style: none;
  max-height: 400px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #333333;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const DropdownItem = styled.li`
  display: ${({ displayItem }) => (displayItem ? 'none' : 'flex')};
  padding: 6px;
  background-color: ${({ selected }) => (selected ? '#333333' : ' #666666')};
  color: 'white';
  cursor: pointer;

  &:hover {
    background-color: #333333;
  }
`;

const InputWrapper = styled.div`
  display: ${({ displayFilter }) => (displayFilter ? ' inline-flex' : ' none')};
  width: 100%;
  align-items: center;
  border: none;
  outline: none;
  background-color: #666666;
  color: white;
  padding: 6px;
  border-bottom: 1px solid;
  justify-content: space-between;
  padding-right: 10px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const InputFilter = styled.input`
  border: none;
  outline: none;
  color: white;
  background-color: #666666;
  text-align: start;
  font-size: 15px;

  ::placeholder {
    color: white;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    color: white;
  }

  ::-ms-input-placeholder {
    color: white;
  }
`;

const CustomDropdown = ({ options, setSelected, margin, displayFilter, reset, fontSizeEnabled, fixed }) => {
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [showOptions, setShowOptions] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options);

  const placeHolders = [
    getTranslatedKey('seleccionaCerca'),
    getTranslatedKey('selectedLayerPH'),
    getTranslatedKey('nomMun'),
    getTranslatedKey('selectedTipusViaPH')
  ];
  useEffect(() => {
    setSelectedOption(options[0]);
  }, [options, reset]);

  useEffect(() => {
    if (showOptions) {
      document.getElementById('dropDownInput').focus();
    }
  }, [showOptions]);

  const toggleOptions = () => {
    setShowOptions(!showOptions);
    setFilteredOptions(options);
  };

  const selectOption = (option) => {
    setSelectedOption(option);
    setSelected(option);
    setShowOptions(false);
  };

  const handleFilterChange = (text) => {
    let search = normalizeText(text);
    let filteredOpts = [];
    options.forEach((option) => {
      if (option && option !== '') {
        let optionNormalized = normalizeText(option);
        if (optionNormalized?.includes(search)) {
          filteredOpts.push(option);
        }
      }
    });
    setFilteredOptions(filteredOpts);
  };

  return (
    <DropdownContainer fontSizeEnabled={fontSizeEnabled} margin={margin}>
      <DropdownButton onClick={() => toggleOptions()}>
        {selectedOption}
        <svg viewBox="0 0 330 330" fill="#fff" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" width="12" className="sc-fTrzCy">
          <path
            d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"></path>
        </svg>
        {/* <i className="arrow down" /> */}
      </DropdownButton>
      {showOptions && (
        <DropdownListWrapper fixed={fixed}>
          <InputWrapper displayFilter={displayFilter}>
            <InputFilter
              onBlur={() => {
                setTimeout(() => {
                  setShowOptions(false);
                }, 200);
              }}
              id="dropDownInput"
              type="text"
              placeholder={getTranslatedKey('filtrePH')}
              onChange={(e) => handleFilterChange(e.target.value)}
            />
            <svg fill="white" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
            </svg>
          </InputWrapper>
          <DropdownList>
            {filteredOptions.map((option, index) => {
              return (
                <DropdownItem
                  key={index}
                  displayItem={placeHolders.includes(option)}
                  selected={selectedOption === options[index]}
                  onClick={() => selectOption(option)}>
                  {option}
                </DropdownItem>
              );
            })}
          </DropdownList>
        </DropdownListWrapper>
      )}
    </DropdownContainer>
  );
};

export default CustomDropdown;
